<template>
  <div>
    <course-details v-if="showStats" :course="course"></course-details>
    <v-row justify="space-around">
      <v-sheet class="page-content">
        <div class="d-flex justify-end">
          <v-btn
            class="default-action-btn spaced-btn"
            @click="showStats = !showStats"
          >
            {{ showStats ? "Hide Stats" : "Show Stats" }}
          </v-btn>
          <v-spacer />
          <base-speed-dial>
            <v-btn
              class="default-action-btn"
              @click="
                $router.replace({
                  name: 'coursesManager',
                  query: { edit: true }
                })
              "
              v-if="!edit"
            >
              Edit
            </v-btn>
            <v-btn
              class="default-action-btn"
              small
              id="js-view-button"
              @click="
                $router.replace({
                  name: 'coursesManager'
                })
              "
              v-else
            >
              Preview
            </v-btn>
            <v-btn
              class="default-action-btn"
              small
              @click="showAssignCourse = true"
            >
              Manage Items
            </v-btn>
            <v-btn
              @click="overlay = true"
              id="js-add-new-item-button"
              class="default-action-btn"
              small
              >Add New Item</v-btn
            >
          </base-speed-dial>
        </div>

        <div v-if="edit">
          <v-overlay :value="showAssignCourse" class="d-flex overlay">
            <div class="d-flex justify-end">
              <v-btn icon @click="showAssignCourse = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
            <learning-item-assign
              :courseId="parseInt(courseId)"
              @save="learningItemAssign"
            ></learning-item-assign>
          </v-overlay>

          <v-overlay :value="showAssignBadge" class="d-flex">
            <div class="d-flex justify-end">
              <v-btn icon @click="showAssignBadge = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
            <badge-select v-on:badge:select="selectBadge" />
          </v-overlay>

          <base-badge
            badgeIcon="mdi-pencil"
            badgeColor="green"
            :imageUrl="badgeUrl"
            class="center-align"
            style="padding-top: 10px"
            v-on:badge:click="showAssignBadge = true"
          ></base-badge>
          <div>
            <v-text-field
              label="Name"
              :value="name"
              @blur="saveName"
              id="js-course-name-input"
              :rules="textFieldRules"
            ></v-text-field>
            <v-text-field
              label="Description"
              :value="description"
              @blur="saveDescription"
              id="js-course-description-input"
              :rules="textFieldRules"
            ></v-text-field>

            <v-text-field
              label="Folder"
              :value="folder"
              @blur="saveFolder"
              id="js-course-folder-input"
            ></v-text-field>
          </div>
          <learning-items-grid-manager :course-id="parseInt(courseId)" />
          <v-overlay :value="overlay" lass="d-flex" :dark="false">
            <div class="d-flex justify-end">
              <v-btn icon @click="overlay = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
            <add-new-learning-item
              v-on:close:overlay="overlay = false"
            ></add-new-learning-item>
          </v-overlay>
        </div>
        <course-member v-else />
      </v-sheet>
    </v-row>
  </div>
</template>

<script>
import eventMixin from "@/mixins/eventMixin"
import validationMixin from "@/mixins/validationMixin"
import EventBus from "@/lib/eventBus"
import BaseBadge from "@/components/BaseBadge"
import BaseLearningEdit from "@/components/BaseLearningEdit"
import BaseLearningResponsesEdit from "@/components/BaseLearningResponsesEdit"
import BaseSpeedDial from "@/components/BaseSpeedDial"
import AddNewLearningItem from "@/containers/learnings/AddNewLearningItem"
import CourseMember from "@/containers/learnings/CourseMember"
import LearningItemAssign from "@/containers/learnings/LearningItemAssign"
import LearningItemsGridManager from "@/containers/learnings/LearningItemsGridManager"
import BadgeSelect from "@/containers/badges/BadgeSelect"
import CourseDetails from "@/containers/learnings/CourseDetails"

export default {
  components: {
    BaseBadge,
    BaseLearningEdit,
    BaseLearningResponsesEdit,
    BaseSpeedDial,
    CourseMember,
    AddNewLearningItem,
    LearningItemAssign,
    LearningItemsGridManager,
    BadgeSelect,
    CourseDetails
  },
  mixins: [eventMixin, validationMixin],
  props: {
    edit: { type: Boolean, default: true },
    template: { type: Boolean, default: false }
  },
  data: function() {
    return {
      courseId: this.$route.params.id,
      overlay: false,
      showAssignCourse: false,
      showAssignBadge: false,
      showStats: false
    }
  },
  computed: {
    name() {
      let course = this.course
      return course ? course.name : ""
    },
    description() {
      let course = this.course
      return course ? course.description : ""
    },
    folder() {
      return this.course ? this.course.folder : ""
    },
    badgeUrl() {
      let course = this.course
      return course ? course.badge_url : ""
    },
    learningItems() {
      let course = this.course
      return course ? course.learning_items : []
    },
    course() {
      return this.$store.getters["courses/getCourseById"](this.courseId)
    }
  },
  async created() {
    await this.$store.dispatch("courses/loadCourses")
    await this.$store.dispatch("learningItems/loadLearningItems", {})
    EventBus.$emit("title", this.title)
  },
  beforeRouteUpdate(to, from, next) {
    if (to.params.id) {
      this.$store.dispatch("courses/loadCourse", {
        id: to.params.id,
        showTemplates: true,
        includeHidden: true
      })
      this.userId = to.params.id
    }
    next()
  },
  methods: {
    addNewItem() {
      this.$store
        .dispatch("learningItems/addLearningItem", {
          name: "",
          description: "",
          body: ""
        })
        .then(learningItem => {
          this.$store.dispatch("courses/addLearningItemToCourse", {
            courseId: this.$route.params.id,
            learningItemId: learningItem.id
          })
        })
    },
    saveName(e) {
      this.$store.dispatch("courses/updateCourse", {
        id: this.courseId,
        name: e.target.value
      })
    },
    saveDescription(e) {
      this.$store.dispatch("courses/updateCourse", {
        id: this.courseId,
        description: e.target.value
      })
    },
    saveFolder(e) {
      this.$store.dispatch("courses/updateCourse", {
        id: this.courseId,
        folder: e.target.value
      })
    },
    hiddenClass(hidden) {
      let s = ""
      if (hidden) {
        s = "hidden-item"
      }
      return s
    },
    completedClass(status) {
      let s = ""
      if (status) {
        s = "completed-item"
      }
      return s
    },
    selectBadge(badge) {
      this.$store.dispatch("courses/updateCourse", {
        id: this.courseId,
        badgeId: badge.id
      })
      this.showAssignBadge = false
    },
    async learningItemAssign({ available, selected, newAsCopy }) {
      this.showAssignCourse = false

      await this.$store.dispatch("courses/assignLearningItems", {
        courseId: this.courseId,
        learningItemIds: selected.map(el => el.id),
        newAsCopy: newAsCopy
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../scss/variables";
@import "../../scss/buttons";

.hidden-item {
  background-color: #b3b3b3 !important;
}
.completed-item {
  text-decoration: line-through;
}
.course-name {
  color: $orange;
}
.course-description {
  font-style: italic;
  font-size: 1.4em;
  color: $light-grey;
}
.center-align {
  display: flex;
  justify-content: center;
}
</style>
